import { render, staticRenderFns } from "./ValidateCode.vue?vue&type=template&id=5247fb5c&scoped=true"
import script from "./ValidateCode.vue?vue&type=script&lang=js"
export * from "./ValidateCode.vue?vue&type=script&lang=js"
import style0 from "./ValidateCode.vue?vue&type=style&index=0&id=5247fb5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5247fb5c",
  null
  
)

export default component.exports